
export default {
  // 模式
  "common.mode.auto": "Kuzingatia weza wenyewe",
  "common.mode.economy": "Mwenendo wa uchumi",
  "common.mode.exigency": "Mwenendo wa kuzungumzia kiwewe",

  // 设备
  "common.grid": "Mishamba ya umeme",
  "common.evChargers": "Mpangilio wa kuchambua",
  "common.evCharger": "Mpangilio wa kuchambua",
  "common.pv": "Paneli za umeme wa jua",
  "common.inverter": "Inverter (kuchambua voltaji)",
  "common.pcs": "Inverter + betri",
  "common.terminal": "Mashine za mwisho (kwa matumizi)",
  "common.airc": "Machinery ya kuweka hewa (AC)",
  "common.engine": "Moto",
  "common.battery": "Betri",
  "common.metter": "Meter wa umeme (kukadiri umeme)",
  "common.other": "Nyingine",
  "common.power": "Mwezi wa umeme",
  "common.powerTotal": "Jumla ya mwezi wa umeme",
  "common.voltage": "Voltaji",
  "common.electricity": "Umeme",
  "common.current": "Mwendesha wa umeme (amperes)",
  "common.homeUsage": "Jumla ya matumizi ya umeme kwa nyumba",
  "common.battery.power": "Mwezi wa umeme wa betri",

  // 数据
  "common.noDataAvailable": "Hakuna data kwa sasa~",
  "common.tips": "Mawazo",
  "common.reset": "Kuzuiwa kwa awali",
  "common.currencyUnit": "¥",
  "common.submiting": "Inasubmitwa, tafadhali subiri...",
  "common.close": "Funga",
  "common.from": " kutoka kwa",
  "common.useIn": " kwa matumizi ya",
  "common.energyPercent": "Asilimia ya mtiririko wa nishati",
  "common.dataFlow": "Mtiririko wa data",
  "common.getDataIng": "Inachambua data, tafadhali subiri...",
  "common.pageLoading": "Content wa ukurasa unachambua, tafadhali subiri...",
  "common.reseting": "Content wa ukurasa unazuiwa kwa awali, tafadhali subiri...",
  "common.save": "Hifadhi",
  "common.onlyNumberTips": "Unaweza kuzungumzia nambari tu",
  "common.offline": "Offline (hakuwa na internet)",
  "common.online": "Online (ina internet)",
  "common.fault":"Uhalali (kosa)",
  "common.charge": "Kuchambua (umeme)",
  "common.discharge": "Kutoa umeme (kutoka betri)",
  "common.buy": "Kununua",
  "common.sell": "Kuuza",
  "common.loadingInfo": "Inachambua, tafadhali subiri...",

  // 
  "common.moreFeatures": "Funkishoni zaidi",
  "common.confirm": "Thibitisha",
  "common.saveing": "Inahifadhiwa, tafadhali subiri...",
  "common.searchPlacholder": "Andika neno linalotafuta",
  "common.iSee": "Nimeelewa",
  "common.pageErrorTips1": "Ee, kuna kosa kwenye ukurasa~",
  "common.pageErrorTips2": "Jaribu kuchambua ukurasa tena, auwasiliana na mwendesha wa huduma~",
  "common.refresh": "Chambua tena",
  "common.backToHome": "Rudi kwa ukurasa wa kwanza",
  "common.checkTips": "Inachambua, tafadhali subiri...",
  "common.back": "Rudi",
  "common.cancel": "Ghairi",
  "common.optional": "Chaguo (sio lazima)",
  "common.required": "Lazima (haiwezi kuzuiwa)",
  "common.status": "Hali",
  "common.statusNoDelete": "Haijafutwa",
  "common.statusDelete": "Imefutwa",
  "common.submit": "Submitt",
  "common.disable": "Kufuata (kuzuiwa)",
  "common.enable": "Kuwezesha",
  "common.year": "mwaka",
  "common.month": "mwezi",
  "common.day": "siku",
  "common.version": "Verisheni:",
  "common.backHome": " Rudi kwa ukurasa wa kwanza",
  "common.backHomeSorry": " Pole, ukurasa alipotea kwa makosa",
  "common.requestTips1": "Data inachambua, usisubmit tena",
  "common.requestTips2": "Mawazo ya mfumo",
  "common.requestTips3": "Hali ya kuingia imeexpire, ingia tena",
  "common.requestTips4": "Ingia tena",
  "common.requestTips5": "Session hauwezi kutumika, au imeexpire, ingia tena.",
  "common.requestTips6": "Kosa wa seva, tafadhali jaribu tena baadaye.",
  "common.requestTips7": "Mwisho wa muda wa kuchambua kwa umoja wa mfumo",
  "common.requestTips8": "Umoja wa mfumo",
  "common.requestTips9": "Uhalali (kosa)",
  "common.iknow": "Nimeelewa",
  "common.logoutSuccess": "Kutoka kwa akaunti umefanikiwa",
  
  // 了解更多组件
  "common.knowMore.title": "Kwa maelezo zaidi, wasiliana na Beineng",
  "common.knowMore.email": "Email ya kontakt",
  "common.knowMore.phone": "Nambari ya simu ya kontakt",
  "common.knowMore.wechat": "WeChat ya kontakt",
  "common.knowMore.website": "Url ya wavuti wa ofisi",
  "common.knowMore.address": "Adresa ya kontakt",
  "common.knowMore.addressDetail": "Chumba 1205, Chumba 1301, Majengo 5, Mtaa wa Qinghe 8, Huangjingkeng, Kijiji cha Huangjiang, Mji wa Dongguan, Jimbo la Guangdong",
  
  // 本地连接组件
  "common.localConnection": "Umoja wa ndani (local)",
  "common.operateInApp": "Fanyiwa kwa app!",
  
  "common.enbleStaus": "Hali ya kuwezesha",
  "common.battery.status": "Hakuna kuchambua na kutoa umeme",

  "account.forgetThePassword": "Kuzungumzia password",
  "account.logInDirectly": "Ingia kwa moja",
  "account.tips1": "Ukurasa unachambua, tafadhali subiri...",
  "account.tips2": "Kwa kwanza weza na uwezi wa mtu!",
  "account.autoLogin": "Ingia kwa mwenendo wa kujitendeka",
  "account.userLogin": "Kuingia kwa mtu",
  "account.registerTips": "Hujaskia akaunti bado? Bonyeza hapa kujiandikisha",
  "account.userEmail": "Jina la mtu / email",
  "account.userEmailTips": "Andika jina la mtu / email",
  "account.password": "Password",
  "account.passwordTips": "Andika password",
  "account.submit": "Submitt",
  "account.submitTips": "Inasubmitwa, tafadhali subiri...",
  "account.otherLoginTips": "Au chagua njia nyingine ya kuingia",
  "account.userRegistration": "Kujandikisha kwa mtu",
  "account.userName": "Jina la mtu",
  "account.userNameTips": "Andika jina la mtu",
  "account.emailTips1": "Andika address ya email",
  "account.emailTips2": "Format ya email hauwezi kutumika",
  "account.phone": "Nambari ya simu",
  "account.phoneTips1": "Andika nambari ya simu",
  "account.phoneTips2": "Nambari ya simu hauwezi kutumika",
  "account.phoneTips3": "Andika nambari ya simu",
  "account.passwordTips1": "Andika password (6-30 herufi)",
  "account.passwordTips2": "Format ya password hauwezi kutumika: password lazima iwe na herufi za Kiingereza, nambari, underscores, dashes na dots, urefu 6-12 herufi",
  "account.passwordTips3": "Password mbili haufanani, jaribu tena!",
  "account.passwordTips4": "Andika password: password lazima iwe na herufi za Kiingereza, nambari, underscores, dashes na dots",
  "account.passwordTips5": "Thibitisha password",
  "account.passwordTips6": "Andika thibitisho la password",
  "account.passwordTips7": "Password mbili haufanani, jaribu tena!",
  "account.passwordTips8": "Andika thibitisho la password",
  "account.passwordTips9": "Hongera, kujandikisha umefanikiwa!",
  "account.passwordTips10": "Jina la mtu lako ni:",
  "account.emailIs": "Email ni:",
  "account.goToLoginPage": "Baada ya s sekunde utachambua kwa ukurasa wa kuingia kwa moja",
  "account.goLogin": "Ingia",
  "account.goRegister": "Jiandikisha",
  "account.loginSuccess": "Kuingia umefanikiwa",
  "account.email": "Email",
  "account.sologn": "Kujenga mwenendo wa nishati wa kujitendeka kwa ajili yako",
  "account.pleaseAgree": "Nimeweza na nimeukubali",
  "userAgreement.privacyPolicy": "Mwenendo wa kuchunguza data za mtu",

  "account.code": "Code ya thibitisho",
  "account.codeTips": "Andika code ya thibitisho",
  "account.codeTips2": "Code ya thibitisho hauwezi kutumika",

    "account.inviteCodeTips": "Tafadhali ingiza msimbo wa mwaliko",
    "account.inviteCodeHint": "Tafadhali wasiliana na mfungaji au wafanyakazi wa uendeshaji na matengenezo kupata msimbo wa mwaliko",
  "account.modifyPasswordByAccount": "Badili password kwa akaunti",
  "account.modifyPasswordByEmail": "Badili password kwa email",
  "account.getPasswordByAccount": "Pata password kwa akaunti",
  "account.getPasswordByEmail": "Pata password kwa email",

  "account.sendEmailTips": "Code ya thibitisho imetumwa kwa email, tafadhali wezi",
  "account.name": "Jina la akaunti",
  "account.newPassword": "Password mpya",
  "account.confirmNewPassword": "Thibitisha password mpya",
  "account.nameTips": "Andika jina la akaunti",
  "account.passwordModifySuccess": "Badilisha password umefanikiwa",
  "account.emailCode": "Code ya thibitisho kwa email",
  "account.emailCodeTips": "Andika code ya thibitisho kwa email",
  "account.emailCodeTips2": "Code ya thibitisho kwa email hauwezi kutumika",
  "account.emailModifySuccess": "Badilisha password umefanikiwa",
  "account.passworTips1": "Password yako imeresetiwa kwa mafanikiwa!",
  "account.passwordTips11": "Andika thibitisho la password",
  "account.passwordTips12": "Andika password mpya",
  "account.nickname": "Jina la mchezo wa mtu",
  "account.modifyNickname": "Badili jina la mchezo wa mtu",
  "account.modifyNicknameSuccess": "Badilisha jina la mchezo wa mtu umefanikiwa!",
  "account.nicknameTips": "Andika jina la mchezo wa mtu",
  "account.nicknameError": "Badilisha jina la mchezo wa mtu hauwezi kutumika!",

  "account.login": "Ingia",
  "account.quickRegister": "Jiandikisha kwa haraka",
  "account.sendCode": "Tuma code",
  "account.sendTips": "Baada ya s sekunde unaweza tuma tena",
  "account.sendEmailIng": "Inatumia email, tafadhali subiri...",
  "account.emailNotEmpty": "Address ya email hauwezi kuwa wazi",
  "account.registerAccount": "Jiandikisha akaunti",
  "account.registerWelcome": "Karibu kujandikisha kwa SusprSafe",
  "account.usernameLimit": "Jina la mtu lazima ianze na herufi na iwe na herufi, nambari na underscores tu, urefu 5-15 herufi",

  "copyright.desc2": "Maelezo ya备案 ya wavuti: ICP备案 Guangdong No. 2021169764",

  "editUserInfo.editUserInformation": "Badili maelezo za mtu",
  "editUserInfo.modifyUsername": "Badili jina la mtu",
  "editUserInfo.changePictures": "Badili picha ya profile",
  "editUserInfo.savePicturesSuccess": "Picha ya profile ya mtu imesavewa kwa mafanikiwa",
  "editUserInfo.saveError": "Hifadhiwa hauwezi kutumika",
  "editUserInfo.pictureLimit": "Picha lazima iwe ndogo kuliko 2 MB",
  "editUserInfo.uploadPicture": "Pakia picha ya profile",
  "editUserInfo.picturePreview": "Angalia kwa mbele",
  
  "editUserInfo.bindPhoneNumber": "Umbiliziwa kwa nambari ya simu",
  "editUserInfo.bindEmail": "Umbiliziwa kwa email",
  "editUserInfo.changePassword": "Badili password",

  "editUserInfo.notificationSettings": "Mwenendo wa notification",
  "editUserInfo.editAccount": "Badili maelezo za akaunti ya mtu",
  "editUserInfo.waitBingting": "Inatumia umbiliziwa, tafadhali subiri...",
  "editUserInfo.collapse": "Funga kwa makosa",
  "editUserInfo.modifyBinding": "Badili umbiliziwa",
  
  "editUserInfo.emailAddress": "Address ya email",
  "editUserInfo.tips1": "Umbiliziwa kwa email umefanikiwa",
  "editUserInfo.tips2": "Hifadhiwa hauwezi kutumika",
  "editUserInfo.tips3": "Inatumia code ya thibitisho kwa email, tafadhali subiri...",
  "editUserInfo.tips4": "Code ya thibitisho imetumwa kwa email xxxx, tafadhali wezi",
  "editUserInfo.tips5": "Tuma code ya thibitisho hauwezi kutumika!",
  "editUserInfo.tips6": "Nambari ya simu tayari imetengwa",
  "editUserInfo.tips7": "Email tayari imetengwa",
  "editUserInfo.emailTips1": "Andika address ya email",
  "editUserInfo.emailTips2": "Format ya address ya email hauwezi kutumika",
  "editUserInfo.emailTips3": "Baada ya xxxx sekunde unaweza tuma tena",
  "editUserInfo.emailTips4": "Tuma kodi",
  "editUserInfo.emailTips5": "Code ya thibitisho kwa email hauwezi kuwa wazi",
  "editUserInfo.emailTips6": "Code ya thibitisho kwa email hauwezi kutumika",
  "editUserInfo.emailCode": "Code ya thibitisho kwa email",
  "editUserInfo.save": "Hifadhi",

  "editUserInfo.phoneTips1": "Umbiliziwa kwa nambari ya simu umefanikiwa",
  "editUserInfo.phoneTips2": "Inatumia code ya thibitisho kwa SMS, tafadhali subiri...",
  "editUserInfo.phoneTips3": "Code ya thibitisho kwa SMS imetumwa kwa simu xxxx, tafadhali wezi",
  "editUserInfo.phoneTips4": "Tuma code ya thibitisho kwa SMS hauwezi kutumika!",
  "editUserInfo.phoneTips5": "Andika nambari ya simu",
  "editUserInfo.phoneTips6": "Format ya nambari ya simu hauwezi kutumika",
  "editUserInfo.phoneTips7": "Tuma code ya thibitisho kwa SMS",
  "editUserInfo.phoneTips8": "Code ya thibitisho kwa SMS",
  "editUserInfo.phoneTips9": "Code ya thibitisho kwa SMS hauwezi kuwa wazi",
  "editUserInfo.phoneTips10": "Code ya thibitisho kwa SMS hauwezi kutumika",
  "editUserInfo.phone": "Nambari ya simu",


  "editUserInfo.noticeTips1": "Pata mwenendo wa notification hauwezi kutumika!",
  "editUserInfo.noticeTips2": "Mwenendo wa notification imesavewa kwa mafanikiwa!",
  "editUserInfo.noticeTips3": "Notification ya umeme wa betri wa chini",
  "editUserInfo.noticeTips4": "Notification ya kuzungumzia machine ya kuchambua magari yenye umeme",
  "editUserInfo.errorNotification": "Notification ya kosa",
  "editUserInfo.updateNotification": "Notification ya update",
  "editUserInfo.monthlyStatisticsNotification": "Notification ya statistics ya mwezi",
  "editUserInfo.notificationMethod": "Njia ya kuchambua",

  "editUserInfo.userNameTips1": "Jina la mtu imesavewa kwa mafanikiwa",
  "editUserInfo.userNameTips2": "Hifadhiwa jina la mtu hauwezi kutumika",
  "editUserInfo.userNameTips3": "Andika jina la mtu",
  "editUserInfo.userNameTips4": "Format ya jina la mtu hauwezi kutumika: lazima iwe na nambari, underscores na herufi za Kiingereza",
  "editUserInfo.userNameTips5": "Andika jina la mtu",
  "editUserInfo.userNameTips6": "Inahifadhiwa, tafadhali subiri...",
  "editUserInfo.userName": "Jina la mtu",

  "editUserInfo.avatorTips": "Bonyeza kwa badili picha ya profile",
  "editUserInfo.verifyCodeTips1": "Andika code ya thibitisho uliyotokea:",
  "editUserInfo.verifyCodeTips2": "Kwa usawa wa akaunti yako, bonyeza button hapa chini kwa tuma code ya thibitisho kwa nambari ya simu wa awali:",
  "editUserInfo.verifyCodeTips3": "Tuma kodi",
  "editUserInfo.verifyCodeTips4": "Thibitisho wa simu wa awali umefanikiwa, andika nambari ya simu mpya wa umbiliziwa",
  "editUserInfo.verifyCodeTips5": "Kwa usawa wa akaunti yako, bonyeza button hapa chini kwa tuma code ya thibitisho kwa email wa awali:",
  "editUserInfo.verifyCodeTips6": "Thibitisho wa email wa awali umefanikiwa, andika email mpya",
  "editUserInfo.verifyCodeTips7": "Password wa awali",
  "editUserInfo.verifyCodeTips8": "Kwa kwanza umbiliziwa kwa email!",
  "editUserInfo.verifyCodeTips9": "Code ya thibitisho imetumwa kwa email, tafadhali wezi",
  "editUserInfo.verifyCodeTips10": ", utachambua kwa ukurasa wa kuingia kwa moja kwa kujitendeka",

  "hems.notice.title": "Jina la notification", 
  "hems.notice.content": "Content ya notification", 
  "hems.notice.operate": "Operate",
  "hems.notice.noRead": "Hajaread",
  "hems.notice.read": "Imewezi",
  "hems.notice.warning": "Warning (on心语)",
  "hems.notice.error": "Error (kosa)",
  "hems.notice.success": "Settlement ya statistics",
  "hems.notice.sys": "Info ya mfumo",
  "hems.notice.operateSuccess": "Operate umefanikiwa",
  "hems.notice.operateTips": "Chagua mwenendo wa operate",

  // 首页
  "hems.home.selfuseRate": "Rate ya kuzingatia weza wenyewe",
  "hems.home.percent": "Asilimia",
  "hems.home.todayData": "Data ya leo",
  "hems.home.todayPowerGeneration": "Uwezi wa umeme wa leo",
  "hems.home.salesIncome": "Mapato ya kuuza umeme",
  "hems.home.saved": "Umeweza kuweza",
  "hems.home.reduce": "Punguza carbon footprint",
  "hems.home.tips1": "Hakuna data kwa sasa, hauwezi umbiliziwa kwa xxxx bado",
  "hems.home.criticalLoad": "Load ya kiwewe (kwa umeme)",
  "hems.home.keyVoltage": "Voltaji wa kiwewe",
  "hems.home.householdLoad": "Load ya nyumba (kwa umeme)",
  "hems.home.householdVoltage": "Voltaji wa nyumba",
  "hems.home.generalLoad": "Load ya kawaida (kwa umeme)",
  "hems.home.generalVoltage": "Voltaji wa kawaida",
  "hems.home.batteryHealth": "Hali ya afya ya betri",
  "hems.home.averageTemp": "Temperature ya wastani",
  "hems.home.gridLoad": "Load ya mishamba ya umeme",
  "hems.home.toggeleDataSource": "Data inazungumzia imechambua kwa:",
  "hems.home.toggleTips": "Je, unaamini unachambua?",
  "hems.home.modeSending": "Command ya mwenendo inatumwa, tafadhali subiri...",
  "hems.home.modeSuccess": "Command ya kubadili mwenendo imetumwa kwa mafanikiwa!",
  "hems.home.isOnline": "Je, ina internet?",
  "hems.home.useStatus": "Hali ya matumizi",
  "hems.home.workModeText": "Mwenendo wa kazi wa sasa:",
  "hems.home.toggleDataSourceText": "Data inazungumzia imechambua kwa:",
  "hems.ev.charge.status": "Hali ya kuchambua (umeme)",
  "hems.ev.charge.time": "Muda wa kuchambua (umeme)",
  "hems.ev.charge.count": "Kiasi cha umeme cha kuchambua kwa sasa",
  "hems.ev.charge.status.empty":"Free (hakuna matumizi)",
  "hems.ev.charge.status.ing":"Kuchambua na kabeli (ina umeme)",
  "hems.ev.charge.status.null":"Kabeli imekuwa ikatengwa lakini haina umeme",
  "hems.ev.charge.status.error":"Error (kosa)",
  "hems.hour":"saa",
  "hems.minue":"dakika",
  "hems.ev.chagre.number": "Nambari ya machine ya kuchambua magari yenye umeme",

  // User Guide
  "hems.userGuide.selfUse": "Kuzingatia weza wenyewe",
  "hems.userGuide.selfUseTips": "Kuzingatia umeme wa jua kwa kwanza, ikiwa hauwezi, uwezi kutoka kwa mishamba ya umeme",
  "hems.userGuide.economyMode": "Mwenendo wa uchumi",
  "hems.userGuide.economyModeTips": "Optimize mwenendo wa matumizi wa umeme kwa haki ya bei",
  "hems.userGuide.emergencyMode": "Mwenendo wa kuzungumzia kiwewe",
  "hems.userGuide.emergencyModeTips": "Kuzingatia load ya kiwewe kwa kwanza (kwa umeme)",

  // 图表页面
  "hems.history.energyStatistics": "Statistics ya nishati",
  "hems.history.revenueStatistics": "Statistics ya mapato",
  "hems.history.greenStatistics": "Punguza emissions ya kijani",
  "hems.history.revenueTitle": "Jumla ya mapato ya kuuza umeme",
  "hems.history.savingsTitle": "Jumla ya uwezi",
  "hems.history.carbonTitle": "Jumla ya punguza emissions ya carbon",
  "hems.history.day": "siku",
  "hems.history.month": "mwezi",
  "hems.history.year": "mwaka",
  "hems.history.beforeDay": "Siku ya awali",
  "hems.history.afterDay": "Siku ya baadaye",
  "hems.history.beforeMonth": "Mwezi wa awali",
  "hems.history.afterMonth": "Mwezi wa baadaye",
  "hems.history.beforeYear": "Mwaka wa awali",
  "hems.history.afterYear": "Mwaka wa baadaye",
  "hems.history.totalUse": "Jumla ya matumizi",
  "hems.history.fullScreen": "Screen wa jumla",
  "hems.history.timeSelect": "Chagua tarehe",
  "sync.tips1": "Command ya synchronize data imetumwa kwa mafanikiwa!",
  "sync.tips2": "Synchronize data inachambua, kwa sababu ya kiasi kubwa cha data, inachambua kwa muda, jaribu angalia tena baada ya nusu saa~",
  "sync.tips3": "Synchronize data ya mashine inaweza kuwa na delay, ikiwa unaona data haufanani, bonyeza:",
  "sync.tips4": "Synchronize data",

  "charge.info": "Maelezo ya machine ya kuchambua magari yenye umeme",
  "news.loading": "Inachambua...",
  "news.noMore": "Hakuna mwenendo wa zaidi",
  "hems.pv.power": "Kiasi cha umeme wa jua",

  // UEH specific
  "ueh.sellPower": "Kiasi cha umeme wa kuuza",
  
  "menu.home": "Ukurasa wa kwanza",
  "menu.history": "Data ya zamani",
  "menu.device": "Mashine",
  "menu.settings": "Mwenendo",
  "menu.messageCenter": "Centri ya message",
  "menu.help": "Msaada na usaidizi",
  "menu.mine": "Yangu",


  "mine.userSetting": "Mwenendo wa mtu",
  "mine.terminalSetting": "Mwenendo wa msingi wa terminal",
  "mine.uploadCloud": "Backup data kwa cloud",
  "mine.changeVersion": "Chambua update",
  "mine.language": "Bonyeza kwa lugha",
  "mine.about": "Kwa app",
  "mine.feedback": "Feedback (mawazo)",
  "mine.logout": "Toka kwa akaunti",
  "mine.logoutAccount": "Futa akaunti",

  "mine.logoutAccountTips": "Futa akaunti na jina []",
  "mine.logoutAccountTips1": "Futa akaunti umbiliziwa kwa []",
  "mine.logoutAccountCare": "Kwa kufuta akaunti, tafadhali wezi mwenendo hapa chini:",
  "mine.logoutAccountCare1": "1. Akaunti ina hali ya usawa",
  "mine.logoutAccountCare1-1": "Akaunti ina hali ya matumizi wa kawaida, hakuna risk ya kuibiwa, kosa au block.",
  "mine.logoutAccountCare2": "2. Autorizatsi na umbiliziwa wa akaunti imeondolewa",
  "mine.logoutAccountCare2-1": "Autorizatsi zote za akaunti kwa platform zingine za第三方 imeondolewa.",
  "mine.logoutAccountCare3": "3. Baada ya kufuta akaunti hauwezi kuirejesha, data za mtu itafutwa",
  "mine.logoutAccountCare3-1": "Baada ya kufuta akaunti, nambari ya simu, email na data zingine za umbiliziwa itafutwa na hauwezi kuirejesha.",
  "mine.confirmLogout": "Thibitisha kufuta",
  "mine.logoutSuccess": "Akaunti imefutwa kwa mafanikiwa!",


  "mine.feedbackIssues": "Feedback kwa problem",
  "mine.feedQuantity": "Kiasi",
  "mine.feedAmount": "Max 9 picha, max size 1 MB/picha",

  "mine.notice.fail": "Pata mwenendo wa notification hauwezi kutumika!",
  "mine.notice.saveSuccess": "Mwenendo wa notification imesavewa kwa mafanikiwa!",
  "mine.notice.saveFail": "Hifadhiwa hauwezi kutumika!",
  "mine.notice.title": "Mwenendo wa notification",
  "mine.notice.batteryLow": "Notification ya umeme wa betri wa chini",
  "mine.notice.chargingFinish": "Notification ya kuzungumzia machine ya kuchambua magari yenye umeme",
  "mine.notice.error": "Notification ya kosa",
  "mine.notice.update": "Notification ya update",
  "mine.notice.monthly": "Notification ya statistics ya mwezi",
  "mine.notice.receiveType": "Njia ya kuchambua",

  "mine.language.welcome": "Karibu kutumika SusprSafe",
  "mine.language.desc1": "Chagua verisheni ya lugha kwa mujibu wa mahali unapoishi",
  "mine.language.desc2": "Unaweza kubadili kwa kwanza kwa mwenendo wa app",

  "mine.userInfo.avatar": "Picha ya profile",
  "mine.userInfo.nickname": "Jina la mchezo",
  "mine.userInfo.password": "Password",
  "mine.userInfo.changePassword": "Badili password",
  "mine.userInfo.setPassword": "Set password",
  "mine.userInfo.phoneNumber": "Nambari ya simu",
  "mine.userInfo.bindPhone": "Umbiliziwa kwa nambari ya simu",
  "mine.userInfo.bindEmail": "Umbiliziwa kwa email",
  "mine.loginExpired": "Hali ya kuingia imeexpire, ingia tena",
  "mine.userInfo.title": "Maelezo ya mtu",
  "mine.userInfo.bind": "Umbiliziwa",
  "mine.userInfo.modify": "Badili",
  "mine.userInfo.modifyNickname": "Badili jina la mchezo",
  "mine.userInfo.userNickname": "Jina la mchezo wa mtu",
  "mine.userInfo.selectPic": "Chagua picha kwa pakia",
  "mine.userInfo.saveSuccess": "Hifadhiwa umefanikiwa",
  "mine.userInfo.uploadFail": "Pakia hauwezi kutumika",
  "mine.userInfo.avatarSaveSuccess": "Picha ya profile imesavewa kwa mafanikiwa",
  "mine.userInfo.nameTips1": "Jina la mchezo wa mtu hauwezi kuwa wazi",
  "mine.userInfo.nameTips2": "Andika jina la mchezo wa mtu",

  "common.pleaseSelect": "Tafadhali chagua",
  "question.commonQuestions": "Maswali yanayotokea mara kwa mara",
  "account.toggleLanguage": "Bonyeza kwa lugha",
  "account.localConnection": "Umoja wa ndani (local)",
  "account.selectLanguage": "Tafadhali chagua lugha",
  "account.sendEmailToast": "Code ya thibitisho imetumwa kwa email xxx, tafadhali wezi",
  "account.emailError": "Format ya email hauwezi kutumika",
  "account.sendEmailFail": "Tuma hauwezi kutumika, jaribu tena",
  
  "common.submitting": "Inasubmitwa, tafadhali subiri...",

  "device.page.noData": "Hakuna data kwa sasa, ukurasa huu unaweza angalia kwa app tu",

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
}
